export default "__VITE_ASSET__BqaIpqbc__"